import React from "react";
import Ant from "@expo/vector-icons/AntDesign";
import Entypo from "@expo/vector-icons/Entypo";
import Evill from "@expo/vector-icons/EvilIcons";
import Feather from "@expo/vector-icons/Feather";
import Awesome from "@expo/vector-icons/FontAwesome";
import Awesome5 from "@expo/vector-icons/FontAwesome5";
import Fontisto from "@expo/vector-icons/Fontisto";
import Foundation from "@expo/vector-icons/Foundation";
import Ion from "@expo/vector-icons/Ionicons";
import MaterialCommunity from "@expo/vector-icons/MaterialCommunityIcons";
import Material from "@expo/vector-icons/MaterialIcons";
import Oct from "@expo/vector-icons/Octicons";
import SimpleLine from "@expo/vector-icons/SimpleLineIcons";
import Zocial from "@expo/vector-icons/Zocial";

import { colors, sizes } from "asset/constant";
import { IconProps } from "@expo/vector-icons/build/createIconSet";

const size = 18;

const Icon = (props: IconT & IconProps<any>) => {
  const renderIcon = () => {
    switch (props.type) {
      case "antDesign":
        return (
          <Ant
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "entypo":
        return (
          <Entypo
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "evill":
        return (
          <Evill
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "feather":
        return (
          <Feather
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "fontAwesome":
        return (
          <Awesome
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "fontAwesome5":
        return (
          <Awesome5
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "fontIsTo":
        return (
          <Fontisto
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "foundation":
        return (
          <Foundation
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "ion":
        return (
          <Ion
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "material":
        return (
          <Material
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "materialCommunity":
        return (
          <MaterialCommunity
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "oct":
        return (
          <Oct
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "simpleLine":
        return (
          <SimpleLine
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
      case "zocial":
        return (
          <Zocial
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );

      default:
        return (
          <Ant
            color={props.color || colors.icon.normal}
            size={size}
            {...props}
          />
        );
    }
  };

  return <>{renderIcon()}</>;
};

export default Icon;
